import { render, staticRenderFns } from "./AvailableReservations.vue?vue&type=template&id=64d4b53e"
import script from "./AvailableReservations.vue?vue&type=script&lang=js"
export * from "./AvailableReservations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports